import { connect } from 'react-redux'
import { DataTable, DialogContainer } from 'react-md'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FieldArray, reduxForm } from 'redux-form'

import { breakLine } from 'lib/formatter'
import { getIsFetchingSizes, getSizes } from 'redux/reducers'
import * as actions from 'redux/actions'

import ListBody from './ListBody'
import ListHeader from './ListHeader'

class CommissionList extends Component {
  constructor (props) {
    super(props)

    this.state = {
      helpMessage: ''
    }

    this.onHelpMessage = this.onHelpMessage.bind(this)
    this.clearHelpMessage = this.clearHelpMessage.bind(this)
  }

  onHelpMessage (message) {
    this.setState({
      helpMessage: message
    })
  }

  clearHelpMessage () {
    this.setState({
      helpMessage: ''
    })
  }

  componentWillMount () {
    const { isFetchingSizes, loadSizes, sizes } = this.props
    if (!sizes.length && !isFetchingSizes) {
      loadSizes()
    }
  }

  render () {
    const { form, frameType, sizes, visible } = this.props

    const { helpMessage } = this.state

    return frameType && sizes.length && visible ? (
      <div>
        <DialogContainer
          id='help-message-dialog'
          visible={!!helpMessage}
          onHide={this.clearHelpMessage}
          title='Info'
          focusOnMount={false}
          portal
          width={500}
        >
          <p>{ breakLine(helpMessage) }</p>
        </DialogContainer>
        <DataTable plain className='commission-table'>
          <ListHeader onHelpMessage={this.onHelpMessage} />
          <FieldArray
            {...this.props}
            id={`${form}-commissions`}
            name='commissions'
            component={ListBody}
          />
        </DataTable>
      </div>
    ) : null
  }
}

CommissionList.propTypes = {
  sizes: PropTypes.array.isRequired,
  isFetchingSizes: PropTypes.bool.isRequired
}

const mapStateToProps = (state) => ({
  isFetchingSizes: getIsFetchingSizes(state),
  sizes: getSizes(state)
})

const CommissionListForm = reduxForm({
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
  pure: false
})(CommissionList)

export default connect(mapStateToProps, actions)(CommissionListForm)



// WEBPACK FOOTER //
// ./src/containers/ArtworkView/CommissionsView/CommissionList/index.js